module.exports = __webpack_public_path__ + "static/media/SK01@l.e8bd468e.jpg";